export const blockIconsPlacesApartment = (
	<span className='material-symbols-outlined'>apartment</span>
);
